// /data/Media.tsx
const MediaArticles = [
  {
    image: '/images/media/dna-strand.webp',
    imageAlt: 'DNA Strand',
    publication: 'VelocityOKC',
    date: '2022-04-22',
    headline:
      'How Collaboration can Lead to Innovation: A Conversation with General Genomics',
    subhead:
      'Oklahoma City is in the middle of an ever-changing world as a city on the brink of change itself. In today’s global economy, the city would often be viewed as a pitstop on the way to a “bigger and better” destination. But to anyone who has driven I-35 through the nation’s heartland and turned that pitstop into a lengthy, Oklahoma “stay awhile,” they would have noticed something worth staying for and investing in.',
    url: 'https://www.velocityokc.com/blog/economy/how-collaboration-can-lead-to-innovation-a-conversation-with-general-genomics',
    id: 'velocityokc-interview',
  },
  {
    image: '/images/media/doctor-tablet.jpg',
    imageAlt: 'Alt tag for innovation lab',
    publication: 'PRNewswire',
    date: '2022-07-26',
    headline:
      'Moleculera Labs and General Genomics Form Strategic Alliance to Utilize Proprietary AI to Provide Personalized Medicine for Autoimmune Neuropsychiatric Disorders',
    subhead:
      "Moleculera Labs, Inc. (Moleculera) and General Genomics, Inc. (GGI) announce the formation of a strategic alliance between the two companies. GGI will bring the power of multiple patent-pending healthcare machine learning (ML) and artificial intelligence (AI) innovations to direct individualized healthcare via their Curo46® Engine. Moleculera will contribute its knowledge and expertise in autoimmune neuropsychiatric disorders, along with one of the largest collections of patient data, utilizing Moleculera Labs' Autoimmune Encephalopathy and Basal Ganglia Encephalitis Panel (AE/BGE) also known as the Cunningham Panel™. This blood panel identifies levels of autoantibodies that attack the brain and central nervous system that are associated with certain neurologic, psychiatric, and behavioral disorders.",
    url: 'https://www.prnewswire.com/news-releases/moleculera-labs-and-general-genomics-form-strategic-alliance-to-utilize-proprietary-ai-to-provide-personalized-medicine-for-autoimmune-neuropsychiatric-disorders-301593006.html',
    id: 'prnewswire-moleculera-partnership',
  },
];

export default MediaArticles;
